import React from 'react';
import { Switch, Redirect } from 'react-router-dom';

import {
  SWAPS_NEW,
  withQuery,
} from '../../helpers/routes';

import SwapsOrders from './SwapsOrders';
import TrackingRoute from '../TrackingRoute';

export default ({ orders = [] }) => {
  if (orders.length === 1) {
    return (
      <Redirect to={withQuery(`/equipment-update/${orders[0].orderId}`)} />
    );
  }

  if (orders.length === 0) {
    return (
      <Redirect to={withQuery(SWAPS_NEW)} />
    );
  }

  return (
    <Switch>
      <TrackingRoute component={SwapsOrders} />
    </Switch>
  );
};
